import { render, staticRenderFns } from "./Sortable.vue?vue&type=template&id=7d6ccd52"
import script from "./Sortable.vue?vue&type=script&lang=js"
export * from "./Sortable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports